<div #backTop class="fab fab--back-to-top" [ngStyle]="bottomGapValue">
	<div class="fab__wrapper">
		<div class="fab__trigger" (click)="scrollToTop()" attr.aria-label="{{'bookingSearch.label.backToTop' | ibeadmin | async}}">
			<app-svg class="fab__icon" svg="icons.svg#general--arrow--top" aria-hidden="true" [alt]="'Arrow top'"></app-svg>
			<span class="fab__label">{{'bookingSearch.text.backToTop' | ibeadmin | async}}</span>
		</div>
	</div>
</div>
